var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgShare = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 19.0026C21 20.658 19.6569 22 18 22C16.3431 22 15 20.658 15 19.0026C14.995 18.9194 14.995 18.836 15 18.7528C15.0175 18.5604 14.9245 18.3747 14.76 18.2732L8.22 14.4565C8.05548 14.351 7.84452 14.351 7.68 14.4565C7.18968 14.8075 6.60316 14.9993 6 15.006C4.34315 15.006 3 13.664 3 12.0085C3 10.3531 4.34315 9.01111 6 9.01111C6.60101 9.0119 7.18734 9.19672 7.68 9.54065C7.84452 9.64612 8.05548 9.64612 8.22 9.54065L14.77 5.72392C14.924 5.62338 15.0119 5.44775 15 5.26431C14.995 5.18112 14.995 5.09771 15 5.01452C14.9921 3.60732 15.965 2.3841 17.3388 2.07399C18.7127 1.76388 20.1174 2.45039 20.7158 3.72431C21.3141 4.99822 20.945 6.51651 19.8283 7.37416C18.7117 8.23181 17.1483 8.19787 16.07 7.29258L9.23 11.2892C9.06548 11.3906 8.97255 11.5764 8.99 11.7687C9.00333 11.935 9.00333 12.1021 8.99 12.2683C8.97255 12.4607 9.06548 12.6464 9.23 12.7479L15.78 16.5646C15.9445 16.6701 16.1555 16.6701 16.32 16.5646C16.8091 16.2101 17.3958 16.0147 18 16.0051C19.6569 16.0051 21 17.3471 21 19.0026Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShare, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/share.27a069a6.svg";
export { ForwardRef as ReactComponent };